module.exports = __webpack_public_path__ + "teqbahn-assets/media/video_1.92691a33.png";